import { Component, Inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { OrderApi, OrderDTO } from '@lkp/parking-sdk';
import { ORDER_API } from '../../../core/providers/api.module';
import { Subject, takeUntil } from 'rxjs';

@Component({
    selector: 'app-confirm',
    templateUrl: './confirm.component.html',
    styleUrls: ['./confirm.component.scss'],
    standalone: false
})
export class ConfirmComponent implements OnInit {
  readonly onDestroy$ = new Subject();
  orderId: number | undefined;
  paymentId: number | undefined;
  klarnaSnippet!: string;
  order!: OrderDTO;

  constructor(
    readonly activatedRoute: ActivatedRoute,
    @Inject(ORDER_API) readonly orderApi: OrderApi
  ) {}

  ngOnInit(): void {
    let temp = this.activatedRoute.snapshot.queryParamMap.get('id');
    let temp2 = this.activatedRoute.snapshot.queryParamMap.get('paymentid');

    if (temp && temp2) {
      this.orderId = parseInt(temp, 10);
      this.paymentId = parseInt(temp2, 10);
      this.getOrder();
    } else if (temp) {
      this.orderId = parseInt(temp, 10);
      this.getOrder();
    }
  }

  getOrder() {
    if (this.paymentId) {
      this.orderApi
        .readOrderPrivate({ paymentId: this.paymentId })
        .pipe(takeUntil(this.onDestroy$))
        .subscribe((orderResponse) => {
          if (orderResponse.htmlSnippet) {
            this.klarnaSnippet = orderResponse.htmlSnippet;

            if (this.orderId) {
              this.orderApi
                .getOrderPrivate({ orderId: this.orderId })
                .pipe(takeUntil(this.onDestroy$))
                .subscribe((order) => {
                  this.order = order;
                });
            }
          }
        });
    } else {
      // No payment, fetch order
      if (this.orderId) {
        this.orderApi
          .getOrderPrivate({ orderId: this.orderId })
          .pipe(takeUntil(this.onDestroy$))
          .subscribe((order) => {
            this.order = order;
          });
      }
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next(undefined);
    this.onDestroy$.complete();
  }
}
